/* src/app/components/show-on-map-venue-dialog/show-on-map-venue-dialog.component.scss */
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 17px 20px;
  margin: 0;
  border-radius: 16px;
  background: #F6F1EF;
}
.container .cross {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 25px;
  height: 25px;
  z-index: 99;
  margin: 0px;
  background: var(--color-white-accent);
  min-width: 25px;
  min-height: 25px;
  max-width: 25px;
  max-height: 25px;
  padding: 0px;
  z-index: 99;
}
.container .cross ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.container .cross:hover {
  background: #f2dbd9;
}
.title {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  margin-bottom: 8px;
  text-transform: uppercase;
}
.info {
  font-size: 13px;
  line-height: 15px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--color-black);
  margin-bottom: 55px;
  text-transform: uppercase;
}
.button {
  height: 25px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}
.button:last-child {
  margin-bottom: 0;
}
.button:hover {
  background: #f2dbd9;
}
.button_main {
  background: var(--not-active-btn);
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  border-radius: 26px;
  text-transform: uppercase;
}
.button_main:hover {
  --background: #f2dbd9 !important;
}
.button_close {
  background: transparent;
  text-transform: uppercase;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  border: 1px solid var(--ion-color-primary);
  border-radius: 26px;
  color: var(--color-black);
  border: 1px solid var(--color-black);
}
/*# sourceMappingURL=show-on-map-venue-dialog.component.css.map */
